import React from "react";
export default function OurCoreMission() {
  const missionPhrases = [{
    id: 3,
    text: "Our goal is to be a technology partner our clients can rely on long term."
  }];
  return <section data-section-id="244025" id="accountabilitycomparison" className="bg-background text-foreground py-24 px-6 md:px-12 flex flex-col items-center justify-center text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center w-full">
        <p className="font-mono text-secondary text-sm uppercase tracking-widest mb-4">
          Our Commitment
        </p>

        <div className="flex h-3 w-full max-w-md py-12 items-center justify-center">
          <div className="flex h-1.5 w-full rounded-lg overflow-hidden shadow-md">
            <div className="flex-1 bg-primary"></div>
            <div className="flex-1 bg-chart-2"></div>
            <div className="flex-1 bg-chart-1"></div>
            <div className="flex-1 bg-secondary"></div>
            <div className="flex-1 bg-chart-2"></div>
            <div className="flex-1 bg-primary"></div>
            <div className="flex-1 bg-secondary"></div>
            <div className="flex-1 bg-chart-1"></div>
          </div>
        </div>

        <h2 className="font-default text-2xl md:text-2xl lg:text-3xl font-bold text-foreground uppercase tracking-tight leading-tight flex flex-col gap-4">
          {missionPhrases.map((phrase, i) => <span key={phrase.id} data-index={i} className="block">
              {phrase.text}
            </span>)}
        </h2>
      </div>
    </section>;
}